import React from 'react';
import { GlobalStyles } from '@mui/material';

import CommandbarStyles from '../CommandBar';
import OsanoStyles from '../Osano';
import ToastStyles from '../Toast';
import BaseStyles from '../BaseStyles';

const Styles = () => {
  return (<GlobalStyles styles={theme => ({
    ...BaseStyles(theme),
    ...CommandbarStyles(theme),
    ...OsanoStyles(theme),
    ...ToastStyles(theme),
  })}
  />);
};

export default Styles;
